import { Component, OnInit } from '@angular/core';
import { SttTableComponent } from '../../../../shared/components/stt-table/stt-table.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { ValidationMessageService } from '../../../../shared/services/base/validation-message-handle';
import { finalize } from 'rxjs/operators';
import { CoccidiostatsModel } from '../../../../shared/entities/coccidiostats.model';
import { CoccidiostatsService } from '../../../../shared/services/app/coccidiostats.service';
import { CoccibiostaticsAddEditComponent } from '../coccibiostatics-add-edit/coccibiostatics-add-edit.component';

@Component({
  selector: 'app-coccibiostatics-action-table',
  templateUrl: './coccibiostatics-action-table.component.html',
  styleUrls: ['./coccibiostatics-action-table.component.scss']
})
export class CoccibiostaticsActionTableComponent implements OnInit {

    public data: CoccidiostatsModel;
    public table: SttTableComponent;
    public ref: DynamicDialogRef;
    public loading = true;

    constructor(
        public dialogService: DialogService,
        public confirmationService: ConfirmationService,
        public primengConfig: PrimeNGConfig,
        public itemService: CoccidiostatsService,
        public messageService: MessageService,
        private validationMessageService: ValidationMessageService,
    ) {

    }

    ngOnInit(): void {
        this.primengConfig.ripple = true;
    }

    setParams(entity: CoccidiostatsModel): void {
        this.data = entity;
    }

    setTableReference(table: SttTableComponent): void
    {
        this.table = table;
    }


    showDialog() {
        this.ref = this.dialogService.open(CoccibiostaticsAddEditComponent, {
            header: 'Modificare Coccidiostatice',
            width: '30%',
            contentStyle: {'max-height': '70vh'},
            baseZIndex: 10000,
            closeOnEscape: false,
            data: this.data,
        });

        this.ref.onClose.subscribe((coccidiostats: CoccidiostatsModel) => {
            if (coccidiostats) {
                this.table.refresh();
            }
        });
    }


    confirm() {
        this.confirmationService.confirm({
            header: 'Confirmare stergere Coccidiostatice',
            message: 'Sunteti sigur ca doriti sa stergeti aceasta coccidiostatica?',
            key: 'deleteCoccibiostatics',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Da',
            rejectLabel: 'Nu',
            acceptButtonStyleClass: 'p-button-md p-button-success',
            rejectButtonStyleClass: 'p-button-md p-button-danger',
            accept: () => {
                this.deleteItem(this.data.uid);
            },
            reject: () => {
                this.confirmationService.close();
                this.table.refresh();
            }
        });
    }

    deleteItem(uid: string){
        this.itemService.delete(uid)
            .pipe(finalize(() => {this.loading = false;this.table.refresh();}))
            .subscribe((response: any) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Coccidiostatica a fost stearsa cu success!'
                });
            });
    }
}
